import {Fragment} from "react";
import Portal from "../../../layout/Portal";
import Modal from "../../../layout/Modal";
import Button from "../../Button";
import React from "react";

let modal = null;

export class ColorTransform extends React.Component {

    constructor(props) {
        super(props);
        const parse = this.parse();
        this.state = {
            style: parse.style,
            tag: parse.tag
        };
    }

    parse = () => {
        const ret = {style: null, content: null};
        const dom = new DOMParser().parseFromString(this.props.value || "<html><head/><body/></html>", 'text/xml');
        let style = this.props.styler || "style#template-style";
        let styleTag = dom.querySelector(style);
        ret.styleTag = styleTag;
        if (styleTag) {
            ret.style = styleTag.innerHTML;
        } else {
            ret.style = null;
        }
        ret.document = dom;
        return ret;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.value !== prevProps.value) {
            const parse = this.parse();
            this.setState({style: parse.style, tag: parse.tag});
        }
    }

    render() {
        return <Fragment>
            <Portal>
                <Modal
                    ref={(selectTemplateModal) => modal = selectTemplateModal}
                    size="large"
                    header="Színek"
                    disabled={this.props.disabled || this.props.isLoading}
                    buttons={[
                        {
                            text: "Mégse",
                            props: {color: "default", disabled: this.props.disabled || this.props.isLoading},
                            onClose: true,
                            onClick: async () => {
                                try {
                                    const r = this.parse();
                                    this.setState({style: r.style});
                                    modal && modal.hide();
                                } catch (e) {

                                }
                            }
                        },
                        {
                            text: "Mentés",
                            props: {color: "primary", disabled: this.props.disabled || this.props.isLoading},
                            onClose: true,
                            onClick: async () => {
                                try {
                                    const r = this.parse();
                                    r.styleTag.innerHTML = this.state.style;
                                    this.props.saveChanges && this.props.saveChanges(r.document.documentElement.outerHTML);
                                    modal && modal.hide();
                                } catch (e) {
                                    console.log(e);
                                }
                            }
                        },
                    ]}
                >
                    <div className="row form-row">
                        <div className="col-md-12">

                        </div>
                    </div>
                </Modal>
            </Portal>
            <Button
                color="default"
                onClick={() => {
                    modal && modal.focus();
                }}
                icon="format_clear"
                tooltip={"Preheader"}
                disabled={this.props.disabled || this.props.isLoading || !this.state.tag}
            />
        </Fragment>
    }
}